// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Button, Segment, Image } from 'semantic-ui-react'
import woocommerce from '../assets/woocommerce.png'

export default class CTAWC extends Component {
  render () {
    return (
      <center className='div2 mb'>
        <Segment fluid basic>
          <Image centered src={woocommerce} style={{ maxWidth: 200 }} />
          <h2>
            <b>
              Convert your WooCommerce store to a native mobile app in a fraction of the time and cost
            </b>
          </h2>
          <h5>Free trial – no credit card required!</h5>
          <br />
          <Button.Group>
            <Button
              circular
              size='large'
              color='black'
              href='/woocommerce'
              style={{ marginRight: '1vh' }}>
              Learn more
            </Button>
          </Button.Group>
        </Segment>
      </center>
    )
  }
}
